import {
	createDefaultVideoListItem,
	getVideoListCoverUrl,
	getVideoListVideoUrl,
	normalizeVideoListData,
} from './videoList.js';
import {
	getPayMediaUnlockKey,
	isPayMediaUnlocked,
	normalizePayMediaPriceFields,
	setPayMediaUnlocked,
} from './payMediaCommon.js';
import { LOCAL_ASSET } from './localAssets.js';

export const PAY_VIDEO_LIST_TYPE = 'pay-video-list';
const UNLOCK_PREFIX = 'pay-video-list';
/** 左侧组件库预览：1 条解锁 + 3 条锁定 */
export const PAY_VIDEO_LIST_COMPACT_FREE_COUNT = 1;
export const PAY_VIDEO_LIST_COMPACT_MAX_ITEMS = 4;

export function createDefaultPayVideoListItems(count = 4) {
	const presets = LOCAL_ASSET.payVideoListPresets;
	const items = [];
	for (let i = 0; i < count; i += 1) {
		items.push(createDefaultVideoListItem(presets[i] || presets[0], i));
	}
	return items;
}

export function getPayVideoListDefaults(extra = {}) {
	const items = createDefaultPayVideoListItems(4);
	const base = normalizeVideoListData({ items });
	const payFields = normalizePayMediaPriceFields({ items }, {
		defaultButtonText: '解锁全部视频',
		maxPreviewCount: base.items.length,
	});
	return {
		...base,
		...payFields,
		title: '精选视频合集',
		subtitle: `共 ${base.items.length} 个精选视频`,
		...extra,
	};
}

export function normalizePayVideoListData(data = {}) {
	const base = normalizeVideoListData(data);
	const payFields = normalizePayMediaPriceFields(data, {
		defaultButtonText: '解锁全部视频',
		maxPreviewCount: base.items.length,
	});
	return {
		...base,
		...payFields,
		title: data.title || '精选视频合集',
		subtitle: data.subtitle || `共 ${base.items.length} 个精选视频`,
	};
}

export function isPayVideoListBlock(type) {
	return type === PAY_VIDEO_LIST_TYPE;
}

export {
	getVideoListCoverUrl,
	getVideoListVideoUrl,
};

export function getPayVideoListUnlockKey(blockId) {
	return getPayMediaUnlockKey(blockId, UNLOCK_PREFIX);
}

export function isPayVideoListUnlocked(blockId) {
	return isPayMediaUnlocked(blockId, UNLOCK_PREFIX);
}

export function setPayVideoListUnlocked(blockId, unlocked = true) {
	setPayMediaUnlocked(blockId, UNLOCK_PREFIX, unlocked);
}

export function getPayVideoListListEntries(data = {}, { unlocked = false, compact = false } = {}) {
	const normalized = normalizePayVideoListData(data);
	const pageCount = normalized.items.length;
	const freeCount = compact
		? Math.min(PAY_VIDEO_LIST_COMPACT_FREE_COUNT, normalized.freePreviewCount, pageCount)
		: normalized.freePreviewCount;
	const displayItems = compact
		? normalized.items.slice(0, PAY_VIDEO_LIST_COMPACT_MAX_ITEMS)
		: normalized.items;

	if (unlocked) {
		return displayItems.map((item, index) => ({
			key: item.id,
			item,
			index,
			locked: false,
		}));
	}

	return displayItems.map((item, index) => ({
		key: item.id,
		item,
		index,
		locked: index >= freeCount,
	}));
}

export function getPayVideoListPreviewDefaults() {
	return normalizePayVideoListData({
		items: createDefaultPayVideoListItems(4),
		freePreviewCount: 1,
	});
}

export function getPayVideoListBlockStyle(data = {}, { h5 = false } = {}) {
	const normalized = normalizePayVideoListData(data);
	const pxRatio = h5 ? 50 : 1;
	return {
		colGap: h5 ? `${12 / pxRatio}rem` : '12px',
		borderRadius: h5 ? `${normalized.videoBorderRadius / pxRatio}rem` : `${normalized.videoBorderRadius}px`,
		itemHeight: h5 ? `${normalized.itemHeight / pxRatio}rem` : `${normalized.itemHeight}px`,
		showCard: normalized.showCard,
	};
}
